import { RippleLoader } from 'components/atoms/RippleLoader';
import React from 'react';
import styled from 'styled-components';

import { Colors } from 'constants/theme';

export const LoadingPage: React.FC<{ text?: string }> = ({
  text = 'Loading'
}) => {
  return (
    <FullPage>
      <RippleLoader color={Colors.sage3} />
      <LoadingMessage>{text}</LoadingMessage>
    </FullPage>
  );
};

const FullPage = styled.main`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingMessage = styled.h2`
  font-family: TeodorLight;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  color: #333333;
`;
